import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISendEmailCredential {
    data: {
        recipients: string[]
        content?: string
        subject?: string
        template?: string
    }
}

export interface IListState {
    status: string
    data: any[]
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const sendEmail = createSlice({
    name: 'send-email/create',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<ISendEmailCredential>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const sendEmailActions = sendEmail.actions
export default sendEmail.reducer
